"use client";

import DisplayImage from "@/components/common/DisplayImage";
import Link from "next/link";
import { EuropeCard, Slider } from "politicamente-informados-ds";
import React from "react";

interface INews {
    slug: string;
    image: string;
    title: string | number;
}

interface Grid {
    items?: INews[];
}

interface IAttrs {
    className?: string;
    style?: Record<string, unknown>;
    grid?: Grid;
    slidesToShow?: number;
    slidesToShowMobile?: number;
    spacing?: string;
    buttonLabel?: string;
    dots?: boolean;
    arrows?: boolean;
    theme?: "light" | "dark";
}

interface IBlockEuropeNews {
    attrs: IAttrs;
}
const BlockEuropeNews: React.FC<IBlockEuropeNews> = ({ attrs }) => {
    const { grid, slidesToShow = 3, slidesToShowMobile = 1, spacing = '', buttonLabel = '', arrows = false, dots = false, theme = 'light' } = attrs;


    const { items } = grid || {};

    if (!items || items.length === 0) {
        return null;
    }
    return (
        <Slider slidesToShow={slidesToShow}
            dots={dots}
            theme={theme}
            arrows={arrows}
            mediaQueries={{
                600: {
                    slidesToShow: slidesToShowMobile,
                    arrows: true,
                    dots: true
                }
            }} infinite={false} spacing={spacing}>
            {items && items.map((item, index) => (
                <EuropeCard
                    key={index}
                    title={item?.title as string ?? ''}
                    linkElement={
                        <Link
                            href={item?.slug as string}
                            aria-label={`Read more about ${item?.title}`}
                            role="link"
                            className="linker"
                        />}
                    buttonLabel={buttonLabel ?? ''}
                    imageElement={
                        <DisplayImage
                            url={item?.image as string}
                            alt={item?.title ? (item?.title as string) : ""}
                            fill={true}
                        />
                    }
                />
            ))}
        </Slider>
    );
};

export default BlockEuropeNews;
